<template>
  <el-dialog
    :visible="visible"
    width="700px"
    append-to-body
    :close-on-click-modal="false"
    class="page-dialog"
    @update:visible="val => emitUpdateVisible(val)"
    @close="handleCancel"
    @closed="handleClosed"
  >
    <template #title>
      <MemberUidHeader :username="targetInfo.username" :uid="uid" :vip-level="targetInfo.vip_level">
        <span class="dialog-subtitle">设置RTP</span>
      </MemberUidHeader>
    </template>

    <el-form v-loading="loading" ref="formRef" :model="form" :rules="rules" label-width="80px" size="mini">
      <el-form-item label="RTP" prop="rtp">
        <el-input-number
          v-model="form.rtp"
          placeholder="输入0-97之间的数字"
          clearable
          :min="0"
          :max="97"
          style="width: 210px"
        />
        <div class="rtp-range-hint">
          <span>RTP范围 0-97,0表示与大盘一致</span>
        </div>
      </el-form-item>
    </el-form>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleConfirm">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { getCurrentInstance, reactive, ref, watch } from 'vue'
import { MemberApi } from '@/api/member/member'
import MemberUidHeader from './MemberUidHeader.vue'

export default {
  name: 'SetRtpDialogV2',
  components: { MemberUidHeader },
  props: {
    visible: { type: Boolean, default: false },
    uid: { type: [Number, String], default: null },
    targetInfo: { type: Object, default: () => ({}) },
    initialRtp: { type: [Number, String], default: '' },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance()
    const formRef = ref(null)
    const submitting = ref(false)
    const form = reactive({
      rtp: '',
    })
    const validateRtp = (rule, value, callback) => {
      const text = String(value ?? '').trim()
      if (!text) return callback(new Error('请输入RTP'))
      const n = Number(text)
      if (Number.isNaN(n)) return callback(new Error('请输入数字'))
      if (n < 0 || n > 97) return callback(new Error('RTP范围需在0-97'))
      return callback()
    }

    const rules = {
      rtp: [{ validator: validateRtp, trigger: 'blur' }],
    }

    const emitUpdateVisible = val => emit('update:visible', val)

    const syncForm = () => {
      form.rtp = props.initialRtp != null && props.initialRtp !== '' ? String(props.initialRtp) : ''
    }
    const loading = ref(false)
    const initRtp = async () => {
      loading.value = true
      try {
        const res = await MemberApi.getPlayerRtp(Number(props.uid))
        form.rtp = res.data?.rtp
      } finally {
        loading.value = false
      }
    }

    watch(
      () => props.visible,
      v => {
        if (v) initRtp()
      },
      { immediate: true }
    )

    const handleCancel = () => {
      if (submitting.value) return
      emitUpdateVisible(false)
    }

    const handleConfirm = () => {
      formRef.value?.validate(async valid => {
        if (!valid) return
        if (!props.uid) return
        submitting.value = true
        try {
          const res = await MemberApi.setRtp({
            uid: Number(props.uid),
            rtp: Number(String(form.rtp).trim()),
          })
          if (res.code === 0) {
            emit('success')
            emitUpdateVisible(false)
          } else {
            proxy?.$message?.error(res.msg || '设置RTP失败')
          }
        } catch (e) {
          proxy?.$message?.error('设置RTP失败')
        } finally {
          submitting.value = false
        }
      })
    }

    const handleClosed = () => {
      formRef.value?.clearValidate?.()
      form.rtp = ''
    }

    return {
      formRef,
      form,
      rules,
      loading,
      submitting,
      emitUpdateVisible,
      handleCancel,
      handleConfirm,
      handleClosed,
    }
  },
}
</script>

<style lang="scss" scoped>
.dialog-subtitle {
  color: #606266;
  font-weight: 500;
}
.rtp-range-hint {
  font-size: 12px;
  color: #909399;
}
</style>
